import clean, * as sanitizeHtml from 'sanitize-html'

const customVgsTags = [
  'expand-element',
  'code-block',
  'file-download',
  'file-download-block',
  'file-download-inline',
  'glossary',
  'gloss-collection',
  'highlighted-box',
  'math-formula',
  'term-explanation-button',
  'read-more',
  'color-box',
  'template',
  'img',
  'math',
  'mrow',
  'mi',
  'mn',
  'mo',
  'mrow',
  'msqrt',
  'mn',
  'maction',
  'ms',
  'menclose',
  'mfenced',
  'mfrac',
  'mglyph',
  'mlabeledtr',
  'mmultiscripts',
  'mover',
  'mpadded',
  'mphantom',
  'mroot',
  'mspace',
  'mstyle',
  'msub',
  'msubsup',
  'msup',
  'mtable',
  'mtd',
  'mtext',
  'mtr',
  'munder',
  'munderover',
  'semantics',
  'source-inline',
  'sentence',
  'geo-gebra-applet',
  'audio-player',
  'video-player',
  'external-link',
  'pronunciation-box-collection'
]

// Removes elements with data-ibexa-preview attribute including its children
const removeIbexaPreview = (frame: sanitizeHtml.IFrame): boolean => {
  return Object.hasOwn(frame.attribs, 'data-ibexa-preview')
}

export const useSanitizer = () => {
  const vgsOptions = {
    allowedClasses: { '*': ['*'] },
    allowedTags: sanitizeHtml.default.defaults.allowedTags.concat(customVgsTags),
    allowedAttributes: false,
    exclusiveFilter: removeIbexaPreview,
  } as sanitizeHtml.IOptions

  const sanitize = (dirty: string): string => clean(dirty, vgsOptions)

  return {
    sanitize
  }
}
